import { DynamicComponentEntity } from '@dotcms/angular';

export const DYNAMIC_COMPONENTS: { [key: string]: DynamicComponentEntity } = {
  Banner: import('../content-types/dot-cms-uve-banner/dot-cms-uve-banner.component').then(
    c => c.DotCmsUveBannerComponent
  ),
  Image: import('../content-types/dot-cms-uve-image/dot-cms-uve-image.component').then(c => c.DotCmsUveImageComponent),
  webPageContent: import('../content-types/dot-cms-uve-web-page-content/dot-cms-uve-web-page-content.component').then(
    c => c.DotCmsUveWebPageContentComponent
  ),
  CustomNoComponent: import('../content-types/dot-cms-uve-fallback/dot-cms-uve-fallback.component').then(
    c => c.DotCmsUveFallbackComponent
  ),
  FaqWidget: import('../content-types/dot-cms-uve-faq-widget/dot-cms-uve-faq-widget.component').then(
    c => c.DotcmsUveFaqWidgetComponent
  ),
  BannerVideo: import(
    '../content-types/dot-cms-uve-video/dot-cms-uve-banner-video/dot-cms-uve-banner-video.component'
  ).then(c => c.DotCmsUveBannerVideoComponent),
  DefaultVideo: import('../content-types/dot-cms-uve-video/dot-cms-uve-video.component').then(
    c => c.DotCmsUveVideoComponent
  ),
  Video: import(
    '../content-types/dot-cms-uve-video/dot-cms-uve-youtube-video/dot-cms-uve-youtube-video.component'
  ).then(c => c.DotCmsUveYoutubeVideoComponent),
  VideoVimeo: import(
    '../content-types/dot-cms-uve-video/dot-cms-uve-vimeo-video/dot-cms-uve-vimeo-video.component'
  ).then(c => c.DotCmsUveVimeoVideoComponent),
  ProductCarousel: import('../content-types/dot-cms-uve-product-carousel/dot-cms-uve-product-carousel.component').then(
    c => c.DotCmsUveProductCarouselComponent
  ),
  CategoryCard: import(
    '../content-types/dot-cms-uve-master-category-card/dot-cms-uve-master-category-card.component'
  ).then(c => c.DotCmsUveMasterCategoryCardComponent),
  Category: import('../content-types/dot-cms-uve-category-list-manual/dot-cms-uve-category-list-manual.component').then(
    c => c.DotCmsUveCategoryListManualComponent
  ),
  ProductsTooltip: import('../content-types/dot-cms-uve-products-tooltip/dot-cms-uve-products-tooltip.component').then(
    c => c.DotCmsUveProductsTooltipComponent
  ),
  Carousel: import('../content-types/dot-cms-uve-carousel/dot-cms-uve-carousel.component').then(
    c => c.DotCmsUveCarouselComponent
  ),
  GlobalCarousel: import('../content-types/dot-cms-uve-global-carousel/dot-cms-uve-global-carousel.component').then(
    c => c.DotCmsUveGlobalCarouselComponent
  ),
  Blog: import('../content-types/dot-cms-uve-blog/dot-cms-uve-blog.component').then(c => c.DotCmsUveBlogComponent),
  dotImage: import('../content-types/dot-cms-uve-image/dot-cms-uve-image.component').then(
    c => c.DotCmsUveImageComponent
  ),
  dotVideo: import('../content-types/dot-cms-uve-video/dot-cms-uve-video.component').then(
    c => c.DotCmsUveVideoComponent
  ),
};
